<div
  class="custom-help-tooltip-container {{
    tooltipDirection === 'top'
      ? 'top-direction'
      : tooltipDirection === 'custom'
        ? 'custom-direction'
        : tooltipDirection === 'status-code-custom'
          ? 'status-code-custom-direction'
          : tooltipDirection === 'for-default-location'
            ? 'default-location-help-tooltip'
            : tooltipDirection === 'department'
              ? 'department'
              : tooltipDirection === 'custom-tooltip-airline'
                ? 'airline'
                : tooltipDirection === 'num-range-priority'
                  ? 'num-range-priority'
                  : 'right-direction'
  }}"
  [style.--custom-tooltip-width]="tooltipWidth">
  <div class="help-container-tooltip">
    <div class="ibc-body-table-text-small">{{ tooltipText }}</div>
    <app-svg-icon
      class="cursor helpTooltipCloseIcon"
      [iconName]="'tooltipClose'"
      [isStaticSvg]="true"
      [isFrom]="'Page'"
      (staticIconClicked)="tooltipDismiss()"></app-svg-icon>
  </div>
</div>
